import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import "react-dates/initialize";
import useUniqueId from "../../../../../Hooks/useUniqueId";
import NoteTypeService from "../../../../../../Services/NoteType.service";
import ActivityItemTypeService from "../../../../../../Domain/ActivityItemType/ActivityItemType.service";
import DeprecatedSelect from "../../../../../UI/DeprecatedSelect/DeprecatedSelect";
import useService from "../../../../../Hooks/useService";
import VirtualizedAppService from "../../../../../../Services/VirtualizedApp.service";
export const getItemEventSearchPieceFromNoteFilterState = (state) => {
    if (!state.noteTypes && !state.apps) {
        return null;
    }
    return {
        activityItemTypeIds: [ActivityItemTypeService.NoteId],
        types: state.noteTypes && state.noteTypes.map((type) => type.id),
        virtualizedAppIds: state.apps && state.apps.map((app) => app.id),
    };
};
const NoteFilters = (props) => {
    const makeId = useUniqueId()[1];
    const [apps, loadApps] = useService(VirtualizedAppService.getInternalAppsAndNullOption);
    React.useEffect(() => {
        loadApps();
    }, [loadApps]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("note-types"), className: "sr-only", children: "Note Types" }), _jsx("div", { children: _jsx(DeprecatedSelect.Async, { multi: true, id: makeId("note-types"), placeholder: "Note Types", loadOptions: (search) => NoteTypeService.search(search).then((options) => ({ options })), value: props.search.noteTypes, valueKey: "id", labelKey: "name", onChange: (types) => props.setSearch((search) => (Object.assign(Object.assign({}, search), { noteTypes: types }))) }) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("app"), className: "sr-only", children: "App" }), _jsx(DeprecatedSelect, { multi: true, id: makeId("app"), placeholder: "App", options: apps.data || [], value: props.search.apps, isLoading: apps.isLoading, labelKey: "displayName", valueKey: "id", onChange: (app) => props.setSearch((search) => (Object.assign(Object.assign({}, search), { apps: app }))) })] })] }));
};
export default NoteFilters;
